import React from 'react';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import ServicesContent from '../components/ServicesContent';
import ServicesPricing from '../components/ServicesPricing';
import ServicesName from '../components/ServicesName';
import WeReOpen from '../components/WeReOpen';

const Services = () => {
    return (
        <>
            <Meta title="Services - THE CUTTING BAR" />
            <PageBanner imageUrl="assets/images/background/2.jpg" heading="Services" />
            <ServicesContent />
            <ServicesPricing />
            <ServicesName />
            <WeReOpen />
        </>
    );
}

export default Services;
